export const navItems = [
  { label: "Home", to: "/" },
  { label: "Kompetenzen", to: "#kompetenzen" },
  { label: "Coaching", to: "#coaching" },
  { label: "Termin vereinbaren", to: "#termin" }
];

export const heroContent = {
  bc: {
    titleTop: "BEHAVIOUR",
    titleBottom: "CHANGE",
    highlight: "Verhaltensveränderung, die wirkt → nachhaltig und menschlich.",
    paragraph:
      "Echte Veränderung beginnt nicht im Außen – sondern in dir. Im Bereich Behaviour Change begleite ich dich oder dein Team dabei, alte Muster zu durchbrechen und neue, wirkungsvolle Gewohnheiten zu etablieren.",
  },
  pp: {
    titleTop: "PEAK",
    titleBottom: "PERFORMANCE",
    highlight: "Höchstleistung in Beruf und Leben → mit Fokus und Leichtigkeit.",
    paragraph:
      "Erfolg ist da – aber da steckt noch mehr drin. Im Bereich Executive Coaching & Peak Performance geht es darum, beruflich wie privat auf das nächste Level zu kommen.",
  },
  // Shared content
  ctas: [
    { label: "Kompetenzen", to: "#kompetenzen", variant: "secondary" },
    { label: "Termin vereinbaren", to: "#termin", variant: "default" }
  ],
  rating: { value: 4.9, outOf: 5, votes: 128 },
  personImg:
    "https://customer-assets.emergentagent.com/job_responsive-gsap-hero/artifacts/gj8601c3_2025_04_05_Tom_Oppenhaeuser_9153.png",
  colors: {
    heading: "#A9BBB5", // sanftes Salbeigrün (wie im Figma)
    accent: "#D7EFE7", // Highlight-Hintergrund
    text: "#0F0F10"
  }
};